import { render, staticRenderFns } from "./PasswordChangeForm.vue?vue&type=template&id=39137bc2&scoped=true"
import script from "./PasswordChangeForm.vue?vue&type=script&lang=js"
export * from "./PasswordChangeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39137bc2",
  null
  
)

export default component.exports